import { create } from 'zustand';

type Kind = 'task' | 'request';

/** Diálogos de criação globais (menu Criar, ⌘K, atalhos). */
export const useCreateDialog = create<{
  open: Kind | null;
  projectId?: string;
  show: (k: Kind, projectId?: string) => void;
  close: () => void;
}>((set) => ({
  open: null,
  show: (open, projectId) => set({ open, projectId }),
  close: () => set({ open: null, projectId: undefined }),
}));
